import React from "react"
import pluralize from "pluralize"
import { componentStyles, Text } from "@mallardbay/lib-react-components"

import { useSearch } from "~components/providers/search-provider"
import COPY from "~config/copy-constants"
import type { SearchListingsForSportsmenInput } from "~graphql/generated/graphql"

export default function SearchTitle() {
    const styles = useStyles()
    const { total, isLoading, searchInput } = useSearch()
    const copy = getCopy({ total, isLoading, searchInput })

    return <Text style={styles.title}>{copy}</Text>
}

function useStyles() {
    return componentStyles({
        title: {
            fontSize: { base: "18px", sm: "20px" },
            fontWeight: 600,
        },
    })
}

// exorted for tests
export function getCopy({
    total,
    isLoading,
    searchInput,
}: {
    total: number
    isLoading: boolean
    searchInput: SearchListingsForSportsmenInput
}) {
    const start = isLoading
        ? COPY.SEARCHING
        : pluralize(COPY.LISTING.toLocaleLowerCase(), total, true)

    const parts = [start]
    if (searchInput.text) {
        parts.push(`for "${searchInput.text}"`)
    }

    if (searchInput.state) {
        parts.push(`in ${searchInput.state}`)
    } else if (searchInput.country) {
        parts.push(`in ${searchInput.country}`)
    }

    return parts.join(" ")
}
